const initAuthorsPageCursor = () => {
  let authorCards = document.querySelectorAll('.authors-page .author-card');

  if (!authorCards) {
    return;
  }

  authorCards.forEach((card) => {
    const cardCustomCursor = card.querySelector('.cursor');

    card.addEventListener('mousemove', (e) => {
      cardCustomCursor.style.top = `${e.clientY}px`;
      cardCustomCursor.style.left = `${e.clientX}px`;
    });
  });
};

export { initAuthorsPageCursor };
